import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import {
  REGISTER_USER,
  VERIFY_EMAIL,
  VERIFY_EMAIL_REQUEST_NEW_TOKEN,
  CREATE_COMPANY,
  VERIFY_USER_INVITATION,
  ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT,
  AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET,
  RESET_PASSWORD,
  CHANGE_PASSWORD,
} from "./actionTypes";
import {
  registerUserSuccessful,
  registerUserFailed,
  verifyEmailSuccessful,
  verifyEmailFailed,
  sendNewVerificationEmailSuccessful,
  sendNewVerificationEmailFailed,
  createCompanySuccessful,
  createCompanyFailed,
  verifyUserInvitationSuccessful,
  verifyUserInvitationFailed,
  acceptInviteCreateNewUserAccountSuccessful,
  acceptInviteCreateNewUserAccountFailed,
  authenticationRequestForEmailPasswordResetSuccessful,
  authenticationRequestForEmailPasswordResetFailed,
  resetPasswordSuccessful,
  resetPasswordFailed,
} from "./actions";
import {
  verifyEmailApi,
  sendNewVerificationEmailApi,
  createCompanyApi,
  verifyUserJoinApi,
  acceptInviteCreateNewUserAccountApi,
  authenticationRequestForEmailPasswordResetApi,
  resetPasswordApi,
} from "../../../helpers/fakebackend_helper";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeRegister,
  postJwtRegister,
  registerUserAPI,
} from "../../../helpers/fakebackend_helper";

// initialize relavant method of both Auth
const fireBaseBackend = getFirebaseBackend();

// Is user register successfully then direct plot user in redux.
function* registerUser({ payload: { user } }) {
  try {
    const response = yield call(registerUserAPI, user);
    yield put(registerUserSuccessful(response));
  } catch (error) {
    yield put(registerUserFailed(error));
  }

  // if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
  //   const response = yield call(
  //     fireBaseBackend.registerUser,
  //     user.email,
  //     user.password
  //   );
  //   yield put(registerUserSuccessful(response));
  // } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
  //   const response = yield call(postJwtRegister, "/post-jwt-register", user);
  //   yield put(registerUserSuccessful(response));
  // } else if (process.env.REACT_APP_API_URL) {
  //   const response = yield call(postFakeRegister, user);
  //   // alert("registerUser");
  //   if (response.message === "success") {
  //     yield put(registerUserSuccessful(response));
  //   } else {
  //     yield put(registerUserFailed(response));
  //   }
  // }
  // } catch (error) {
  //   yield put(registerUserFailed(error));
  // }
}

export function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser);
}

// Verify Email
function* verifyEmail(action) {
  try {
    const response = yield call(verifyEmailApi, action.payload);
    yield put(verifyEmailSuccessful(response));
  } catch (error) {
    yield put(verifyEmailFailed(error));
  }
}

export function* watchVerifyEmail() {
  yield takeEvery(VERIFY_EMAIL, verifyEmail);
}

// request new verification token by sending email
function* sendNewVerificationEmail(action) {
  try {
    const response = yield call(sendNewVerificationEmailApi, action.payload);
    yield put(sendNewVerificationEmailSuccessful(response));
  } catch (error) {
    yield put(sendNewVerificationEmailFailed(error));
  }
}

export function* watchSendNewVerificationEmail() {
  yield takeEvery(VERIFY_EMAIL_REQUEST_NEW_TOKEN, sendNewVerificationEmail);
}
// create company

function* createCompany(action) {
  try {
    const response = yield call(createCompanyApi, action.payload);
    yield put(createCompanySuccessful(response));
  } catch (error) {
    yield put(createCompanyFailed(error));
  }
}

export function* watchCreateCompany() {
  yield takeEvery(CREATE_COMPANY, createCompany);
}

// verify user invitation to join a company
function* verifyUserInvitation(action) {
  try {
    const response = yield call(verifyUserJoinApi, action.payload);
    yield put(verifyUserInvitationSuccessful(response));
  } catch (error) {
    yield put(verifyUserInvitationFailed(error));
  }
}

export function* watchVerifyUserInvitation() {
  yield takeEvery(VERIFY_USER_INVITATION, verifyUserInvitation);
}

// accept invite and create new user account
function* acceptInviteCreateNewUserAccount(action) {
  try {
    const response = yield call(
      acceptInviteCreateNewUserAccountApi,
      action.payload
    );
    yield put(acceptInviteCreateNewUserAccountSuccessful(response));
  } catch (error) {
    yield put(acceptInviteCreateNewUserAccountFailed(error));
  }
}

export function* watchAcceptInviteCreateNewUserAccount() {
  yield takeEvery(
    ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT,
    acceptInviteCreateNewUserAccount
  );
}
//authenticationRequestForEmailPasswordResetApi
function* authenticationRequestForEmailPasswordReset(action) {
  try {
    const response = yield call(
      authenticationRequestForEmailPasswordResetApi,
      action.payload
    );
    yield put(authenticationRequestForEmailPasswordResetSuccessful(response));
  } catch (error) {
    yield put(authenticationRequestForEmailPasswordResetFailed(error));
  }
}

export function* watchAuthenticationRequestForEmailPasswordReset() {
  yield takeEvery(
    AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET,
    authenticationRequestForEmailPasswordReset
  );
}

// reset password
function* resetPassword(action) {
  try {
    const response = yield call(resetPasswordApi, action.payload);
    yield put(resetPasswordSuccessful(response));
  } catch (error) {
    yield put(resetPasswordFailed(error));
  }
}

export function* watchResetPassword() {
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

function* accountSaga() {
  yield all([
    fork(watchUserRegister),
    fork(watchVerifyEmail),
    fork(watchSendNewVerificationEmail),
    fork(watchCreateCompany),
    fork(watchVerifyUserInvitation),
    fork(watchAcceptInviteCreateNewUserAccount),
    fork(watchAuthenticationRequestForEmailPasswordReset),
    fork(watchResetPassword),
  ]);
}

export default accountSaga;
